import { Flex, Heading, Text } from "@radix-ui/themes";
import {
  Locale,
  type LocalizedStrings,
  useLocalization,
} from "~/components/localization/LocalizationProvider";
import styles from "./free-consult.module.css";
import { BaseConsultForm } from "~/components/BaseConsultForm";

type Localization = {
  title: string;
  helper: string;
  friendlyGreeting: string;
};

const englishLocalization: Localization = {
  title: "Schedule Your First Consultation",
  helper:
    "Fill out the form below, and you'll hear from our team as soon as possible to schedule your appointment at Miami Orthodontic Specialists.",
  friendlyGreeting: "We look forward to meeting you soon!",
};

const spanishLocalization: Localization = {
  title: "Programa tu primera consulta",
  helper:
    "Complete este formulario a continuación y nuestro equipo se pondrá en contacto contigo lo antes posible para programar tu cita en Miami Orthodontic Specialists.",
  friendlyGreeting: "¡Esperamos verte pronto!",
};

const localized: LocalizedStrings<Localization> = {
  [Locale.EN]: englishLocalization,
  [Locale.ES]: spanishLocalization,
};

export default function FreeConsultPage() {
  const getLocalization = useLocalization(localized);
  return (
    <Flex mt="-20px" width="100dvw" className={styles.baseContainer}>
      <Flex
        gridColumnStart="1"
        gridColumnEnd="6"
        pt="8"
        pb="9"
        className={styles.content}
        direction="column"
        px="5"
        gap="5"
      >
        <Flex direction="column" gap="5">
          <Heading weight="bold" size="8" className={styles.title}>
            {getLocalization("title")}
          </Heading>
          <Text className={styles.greetingText}>
            {getLocalization("helper")}
          </Text>
          <Text className={styles.greetingText}>
            {getLocalization("friendlyGreeting")}
          </Text>
        </Flex>
        <BaseConsultForm source="free-consult" showMessage />
      </Flex>
    </Flex>
  );
}
